import { CALL_API } from "admin/middlewares/api";

export const INVOICES_LIST_GET_REQUEST = "INVOICES_LIST_GET_REQUEST";
export const INVOICES_LIST_GET_SUCCESS = "INVOICES_LIST_GET_SUCCESS";
export const INVOICES_LIST_GET_ERROR = "INVOICES_LIST_GET_ERROR";

export function get_invoices() {
  /*return {
		[CALL_API]: {
			endpoint: '/api/admin/invoices/unpaid',
			authenticatedRequest: true,
			types: [INVOICES_LIST_GET_REQUEST, INVOICES_LIST_GET_SUCCESS, INVOICES_LIST_GET_ERROR]
		}
	};*/
}

export const INVOICE_LIST_CHANGE_PAGE = "INVOICE_LIST_CHANGE_PAGE";

export function change_invoice_list_page(page) {
  return {
    type: INVOICE_LIST_CHANGE_PAGE,
    page,
  };
}

export const INVOICE_LIST_CHANGE_FILTER = "INVOICE_LIST_CHANGE_FILTER";

export function change_invoice_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: INVOICE_LIST_CHANGE_FILTER,
    filter,
  };
}

export const INVOICE_ADD_ROW_REQUEST = "INVOICE_ADD_ROW_REQUEST";
export const INVOICE_ADD_ROW_SUCCESS = "INVOICE_ADD_ROW_SUCCESS";
export const INVOICE_ADD_ROW_ERROR = "INVOICE_ADD_ROW_ERROR";

export function add_invoice_row(invoiceRow) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/addrow",
      method: "POST",
      data: { InvoiceRow: invoiceRow },
      authenticatedRequest: true,
      types: [
        INVOICE_ADD_ROW_REQUEST,
        INVOICE_ADD_ROW_SUCCESS,
        INVOICE_ADD_ROW_ERROR,
      ],
    },
  };
}

export const INVOICE_REMOVE_ROW_REQUEST = "INVOICE_REMOVE_ROW_REQUEST";
export const INVOICE_REMOVE_ROW_SUCCESS = "INVOICE_REMOVE_ROW_SUCCESS";
export const INVOICE_REMOVE_ROW_ERROR = "INVOICE_REMOVE_ROW_ERROR";

export function remove_invoice_row(loanId, invoiceId, rowId, draft) {
  let draftUrl = draft == true ? "/drafts" : "";
  let data =
    draft == true
      ? { LoanId: loanId, DraftId: invoiceId, RowId: rowId }
      : { LoanId: loanId, InvoiceId: invoiceId, RowIds: [rowId] };

  return {
    [CALL_API]: {
      endpoint: "/api/admin/invoices" + draftUrl + "/removerow",
      method: "POST",
      data,
      authenticatedRequest: true,
      types: [
        INVOICE_REMOVE_ROW_REQUEST,
        INVOICE_REMOVE_ROW_SUCCESS,
        INVOICE_REMOVE_ROW_ERROR,
      ],
    },
  };
}

export const INVOICE_REGISTER_PAYMENT_REQUEST =
  "INVOICE_REGISTER_PAYMENT_REQUEST";
export const INVOICE_REGISTER_PAYMENT_SUCCESS =
  "INVOICE_REGISTER_PAYMENT_SUCCESS";
export const INVOICE_REGISTER_PAYMENT_ERROR = "INVOICE_REGISTER_PAYMENT_ERROR";

export function register_invoice_payment(
  loanId,
  customerRefCode,
  staffRefCode,
  amount,
  receiveDate,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/invoices/registerpayment",
      method: "POST",
      data: {
        LoanId: loanId,
        CustomerRefCode: customerRefCode,
        StaffCorrectedRefCode: staffRefCode,
        Amount: amount,
        BankReceiveDate: receiveDate,
      },
      authenticatedRequest: true,
      types: [
        INVOICE_REGISTER_PAYMENT_REQUEST,
        INVOICE_REGISTER_PAYMENT_SUCCESS,
        INVOICE_REGISTER_PAYMENT_ERROR,
      ],
    },
  };
}

export const INVOICE_CANCEL_PAYMENT_REQUEST = "INVOICE_CANCEL_PAYMENT_REQUEST";
export const INVOICE_CANCEL_PAYMENT_SUCCESS = "INVOICE_CANCEL_PAYMENT_SUCCESS";
export const INVOICE_CANCEL_PAYMENT_ERROR = "INVOICE_CANCEL_PAYMENT_ERROR";

export function cancel_invoice_payment(paymentId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/cancelpayment",
      method: "POST",
      data: { PaymentId: paymentId },
      authenticatedRequest: true,
      types: [
        INVOICE_CANCEL_PAYMENT_REQUEST,
        INVOICE_CANCEL_PAYMENT_SUCCESS,
        INVOICE_CANCEL_PAYMENT_ERROR,
      ],
    },
  };
}

// Short term invoices

export const ST_INVOICES_LIST_GET_REQUEST = "ST_INVOICES_LIST_GET_REQUEST";
export const ST_INVOICES_LIST_GET_SUCCESS = "ST_INVOICES_LIST_GET_SUCCESS";
export const ST_INVOICES_LIST_GET_ERROR = "ST_INVOICES_LIST_GET_ERROR";

export function get_st_invoices() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/invoices/shortterm/unpaid",
      authenticatedRequest: true,
      types: [
        ST_INVOICES_LIST_GET_REQUEST,
        ST_INVOICES_LIST_GET_SUCCESS,
        ST_INVOICES_LIST_GET_ERROR,
      ],
    },
  };
}

export const ST_INVOICE_LIST_CHANGE_PAGE = "ST_INVOICE_LIST_CHANGE_PAGE";

export function change_st_invoice_list_page(page) {
  return {
    type: ST_INVOICE_LIST_CHANGE_PAGE,
    page,
  };
}

export const ST_INVOICE_LIST_CHANGE_FILTER = "ST_INVOICE_LIST_CHANGE_FILTER";

export function change_st_invoice_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: ST_INVOICE_LIST_CHANGE_FILTER,
    filter,
  };
}
